import { TaskStatusLabel } from 'ComponentLibrary'
import { UUID } from 'ComponentLibrary/src/common/uuid'
import dayjs from 'dayjs'
import { compact } from 'lodash'
import { TaskAssignee } from 'ComponentLibrary/src/common/users'

export type TaskType = 'system' | 'appraiser' | 'customer'

export type Task = {
    uuid: string
    order: {
        uuid: string
    }
    title: string
    description: string
    status: TaskStatus
    assignee?: TaskAssignee
    due_date?: string
    has_limited_visibility?: boolean
    task_type: TaskType
}

export type TaskStatus = 'open' | 'done'

type IsUrgentProps = Pick<Task, 'status' | 'due_date'>

export const taskIsUrgentOrOverdue = (task?: IsUrgentProps) => {
    if (!task || task.status === 'done' || !task.due_date) {
        return false
    }

    return dayjs(task.due_date).isBefore(dayjs().add(-3, 'day'))
}

const TASK_STATUS_OPTIONS = [
    { label: <TaskStatusLabel typographyVariant="bodyTextLarge" status={'open'} />, value: 'open' },
    { label: <TaskStatusLabel typographyVariant="bodyTextLarge" status={'done'} />, value: 'done' },
]

const ALL_TASK_STATUS_OPTIONS_WITH_OPTIONAL = [{ label: '-', value: '' }, ...TASK_STATUS_OPTIONS]

export const stringIsTaskStatus = (value: string): value is TaskStatus => {
    return TASK_STATUS_OPTIONS.map((statusOption) => statusOption.value).includes(value)
}

export const TASK_STATUS_OPTIONS_CONFIG = {
    all_with_optional: ALL_TASK_STATUS_OPTIONS_WITH_OPTIONAL,
    all: TASK_STATUS_OPTIONS,
}

export function removeDuplicateTasks<T extends { uuid: UUID; status: TaskStatus }>(
    openTasks: T[],
    doneTasks: T[]
): { openTasks: T[]; doneTasks: T[] } {
    const openTaskSet = new Set(openTasks.map((task) => task.uuid))
    const doneTaskSet = new Set(doneTasks.map((task) => task.uuid))
    return {
        openTasks: compact(openTasks.filter((task) => !doneTaskSet.has(task.uuid) || task.status === 'done')),
        doneTasks: compact(doneTasks.filter((task) => !openTaskSet.has(task.uuid) || task.status === 'open')),
    }
}
